

//Teams version Tab.jsx

import { useContext } from "react";
import { TeamsFxContext } from "../teams/Context.jsx";
import { BrowserRouter as Router, Route, Redirect, Switch } from "react-router-dom";

// import MapDefault from "../modules/Map/MapDefault.jsx";
// import MyBooking from "../modules/MyBooking/MyBookingUI.jsx";
// import Colleagues from "../modules/Colleagues/Colleagues.jsx";
// import SettingReact from "../modules/Setting/SettingReact.jsx";
// import Emp1 from "../modules/EmployeeRoles/EmpDesign.jsx"
import InactiveUserResponseHandler from "../modules/Common/InactiveUserResponseHandler.jsx";

// import "../assets/css/bootstrap.min.css";
// import "../assets/css/all.min.css";
// import "../assets/css/common.css";
// import "../assets/css/jquery.mCustomScrollbar.css";
// import "../assets/css/language-dropdown.css";
// import "../assets/css/style.css";
// import "../assets/css/responsive.css";

import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "bootstrap/dist/css/bootstrap.min.css";


import CalendarEvent from "../modules/Calendar/Calendar/CalendarEvent.jsx";
import WeekCalendar from "../modules/WeeklyCalendar/WeeklyCalendarEvent.jsx";
import NewBooking from "../modules/NewBooking/NewBookingUI.jsx";
import MapDefault from "../modules/Map/MapDefault.jsx";
import MyBooking from "../modules/MyBooking/MyBookingUI.jsx";
import Colleagues from "../modules/Colleagues/Colleagues.jsx";
import Emp1 from "../modules/EmployeeRoles/EmpDesign.jsx"
import SettingReact from "../modules/Setting/SettingReact.jsx";
export default function Tab() {

  //   useEffect(() => {
  //   startEventLogger();     // Start event tracking

  //   return () => {
  //     stopEventLogger();    // Cleanup event tracking
  //   };
  // }, []);

  useContext(TeamsFxContext);
  return (
    <Router>
        <InactiveUserResponseHandler />
        {/* <IFrame/> */}
        <Switch>
          {/* Enable this before Staging update */}
          
          {/* <Route exact path="/Login" component={Login} /> */}
          <Route path="/calendar" component={CalendarEvent} />
          {/* <Route path="/calendars" component={Calendar} /> */}

          {/* <Route path="/weeklycalendar" component={TestCalendarTesting} /> */}
          
          {/* <Route path="/mapcanvas" component={MapCanvasZone} /> */}
          <Route path="/map" component={MapDefault} />
          <Route path="/newbooking" component={NewBooking} />
          <Route path="/weekCalendar" component={WeekCalendar} />


          <Route path="/booking" component={MyBooking} />
          <Route path="/colleagues" component={Colleagues} />
          
          <Route path="/roles" component={Emp1} />
          {/* <Route path="/roles" component={Emp1} /> */}
          {/* <Route path="/roles" component={EmployeeRoles} /> */}

          <Route path="/profile" component={SettingReact} />
          
          <Redirect from="/" to="/calendar" />
          {/* <Redirect from="/" to="/" /> */}
        </Switch>
    </Router>

    // <Router>
    //       <InactiveUserResponseHandler />    
    //       {/* <IFrame/> */}
    //   <Switch>
    //     <Route path="/calendar" component={LegacyCalendar} />
    //     <Route exact path="/weekCalendar">
    //       <WeekCalendar />
    //     </Route>
    //     <Route exact path="/newbooking">
    //       <NewBooking />
    //     </Route>
    //     <Route path="/map" component={MapDefault} />
    //     <Route path="/booking" component={MyBooking} />
    //     <Route path="/colleagues" component={Colleagues} />
    //     <Route path="/roles" component={Emp1} />
    //     <Route path="/profile" component={SettingReact} />
    //     <Redirect from="/" to="/" />
    //   </Switch>
    // </Router>
  );
}
